import { render, staticRenderFns } from "./ButtonMore.vue?vue&type=template&id=93678f1a&scoped=true&"
import script from "./ButtonMore.vue?vue&type=script&lang=js&"
export * from "./ButtonMore.vue?vue&type=script&lang=js&"
import style0 from "./ButtonMore.vue?vue&type=style&index=0&id=93678f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93678f1a",
  null
  
)

export default component.exports